import { Outlet } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import style from "./Layout.module.css";

const Layout: React.FC = () => {
  return (
    <div className={style.container}>
      <Header />
      <main className={style.mainContent}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
